import { Stack, type SxProps, type Theme } from "@mui/material";
import { LoadingSpinner, Text } from "@src/appV2/redesign/system/ui-components";

interface LoadingMoreIndicatorProps {
  sx?: SxProps<Theme>;
}

export function LoadingMoreIndicator(props: LoadingMoreIndicatorProps) {
  const { sx } = props;

  return (
    <Stack spacing={5} alignItems="center" sx={sx}>
      <LoadingSpinner size="medium" variant="primary" />

      <Text color={(theme) => theme.palette.text.secondary}>Loading more shifts...</Text>
    </Stack>
  );
}
